module.exports = __webpack_public_path__ + "static/img/o.de5a831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/o.png
// module id = D1ne
// module chunks = 1